import { createSlice } from '@reduxjs/toolkit'

import { addIpAddress } from './ipAddress.actions'

export interface IpAddressState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
}

const initialState: IpAddressState = {
  status: 'idle',
  error: null,
}

export const ipAddressReducer = createSlice({
  name: 'addIpAddress',
  initialState,
  reducers: {},
  extraReducers: {
    [addIpAddress.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [addIpAddress.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
    },
    [addIpAddress.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
}).reducer
